<template>
    <div class="mak-musteri-makina-list">
        <div class="d-flex flex-row justify-space-between align-center pa-4">
            <div class="heading font-weight-medium">Müşteri Kontrol Listesi</div>

            <v-btn
                fab
                dark
                small
                class="mx-2"
                color="deep-purple accent-4"
                @click="kontrolVisible=true"
            >
                <v-icon dark>
                    mdi-plus
                </v-icon>
            </v-btn>
        </div>

        <v-divider/>

        <v-data-table
            :items="list"
            :headers="headers"
            :sort-by="['kontrol_zamani']"
            :sort-desc="[true]"
            :expanded="expanded"
            item-key="id"
            show-expand
            single-expand
            :disable-pagination="true"
            hide-default-footer
        >

            <template v-slot:expanded-item="{ item, headers }">
                <td :colspan="headers.length">
                    <div class="d-flex flex-column align-start pa-6">
                        <div>
                            <b>Tahsilat Tutarı:</b> {{ item.tahsilat_tutari }} <span v-if="item.tahsilat_tutari">₺</span>
                        </div>
                        <div>
                            <b>Dolum ml:</b> {{ item.dolum_ml }} <span v-if="item.dolum_ml">ml</span>
                        </div>
                        <div>
                            <b>Not:</b> {{ item.not }}
                        </div>
                        <div>
                            <b>Kontrolu Yapan:</b> {{ item.kontrolu_yapan }}
                        </div>
                    </div>
                </td>
            </template>

            <template v-slot:item.kontrol_zamani="{ item }">
                <v-chip
                    small
                    color="deep-purple accent-3"
                    dark
                >
                    <v-icon x-small left>mdi-calendar</v-icon>
                    {{ item.kontrol }}
                </v-chip>
            </template>

            <template v-slot:item.tahsilat_yapildi="{ item }">
                <v-chip
                    x-small
                    :color="item.tahsilat_yapildi === '1' ? 'green' : 'orange'"
                    dark
                >
                    {{item.tahsilat_yapildi === '1' ? 'Evet' : 'Hayır'}}
                </v-chip>
            </template>

            <template v-slot:item.dolum_yapildi="{ item }">
                <v-chip
                    x-small
                    :color="item.dolum_yapildi === '1' ? 'green' : 'orange'"
                    dark
                >
                    {{item.dolum_yapildi === '1' ? 'Evet' : 'Hayır'}}
                </v-chip>
            </template>

        </v-data-table>

        <musteri-kontrol-form
            v-model="kontrolVisible"
            :musteri-id="musteriId"
            :kontrol-zamani="kontrolZamani"
            @done="fetch"
        />
    </div>
</template>

<script>
    import moment from 'moment';
    import MusteriKontrolForm from '@/components/MusteriKontrolForm.vue'

    export default {
        name: 'mak-musteri-makina-list',
        props: {
            musteriId: {type: [String, Number], required: true},
        },
        components: { MusteriKontrolForm },
        data() {
            return {
                loading: false,
                expanded: [],
                list: [],
                kontrolVisible: false,
                kontrolZamani: moment(),
                headers: [
                    { text: 'Şirket', value: 'sirket_adi' },
                    { text: 'Kontrol Zamanı', value: 'kontrol_zamani' },
                    { text: 'Tahsilat?', value: 'tahsilat_yapildi' },
                    { text: 'Dolum?', value: 'dolum_yapildi' },
                ],
            };
        },
        methods: {
            fetch() {
                this.loading = true;
                this.$requests.MusteriKontrol
                    .getMusteriKontrolleri(this.musteriId)
                    .then((data) => {
                        this.list = data.map((d) => {
                            d.kontrol = moment(d.kontrol_zamani).format('DD MMM YYYY HH:mm');
                            return d;
                        });
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
        },
    }
</script>
